<template>
    <aside id="popup-step-01" class="layout-coldstart mfp-hide">
        <header class="coldstart-hello">
            <h2 class="title">{{$t('COLDSTART.POPUP.FIRST.MAIN_TITLE')}}</h2>
            <p class="desc">
                {{$t('COLDSTART.POPUP.FIRST.MAIN_INTRO_01')}}
                {{$t('COLDSTART.POPUP.FIRST.MAIN_INTRO_02')}}
                <!--클라우드 환경에서 발생할 수 있는 문제를 사전에 예방하기 위해 클라우드의 운영과 모니터링을 위한 정책을 만들고 적용 시킬 수 있습니다. 기업이 사전에 클라우드 비용을 줄이고 보안 위험을 해결할 수 있도록 클라우드 Governance 정책을 자동화 합니다.-->
            </p>
        </header>


        <div class="coldstart-contetns">

            <dl class="governance-info">
                <dt><span class="policy-management">{{$t('COLDSTART.POPUP.FIRST.POLICY_TITLE')}}</span></dt>
                <dd>
                    {{$t('COLDSTART.POPUP.FIRST.POLICY_INTRO_01')}}
                    {{$t('COLDSTART.POPUP.FIRST.POLICY_INTRO_02')}}
<!--                    정책 관리를 통해 클라우드 비용 및 보안에 대한 정책을 수립하며 정책 검사를 통해 수립된 정책을 자동으로 모니터링을 제공합니다.<br>-->
<!--                    정책에 맞지 않는 경우 사전에 정의된 조치를 자동으로 실행할 수 있습니다.-->
                </dd>
            </dl>


            <!-- 클라우드 계정 미연동시 -->
            <dl v-if="!pending && !isExistAccount" class="governance-info">
                <dt><span class="tip">{{$t('COLDSTART.POPUP.FIRST.LINK_TITLE')}}</span></dt>
                <dd>
                    {{$t('COLDSTART.POPUP.FIRST.LINK_INTRO_01')}}
                    {{$t('COLDSTART.POPUP.FIRST.LINK_INTRO_02')}}
                </dd>
            </dl>

        </div>


        <div class="coldstart-actions">
            <div class="stack-item"></div>
            <div v-if="!pending &&!isExistAccount" class="stack-item">
                <button type="button" class="buttons" data-type="key" v-on:click="moveToPortal()">{{$t('COLDSTART.BUTTON.GO_TO_ACCOUNT')}}<!--클라우드 계정 연동하기--></button>
            </div>
            <div v-else-if="!pending &&isExistAccount" class="stack-item">
                <button type="button" class="buttons" data-type="ghost" v-on:click="finishColdstart()"><span class="link">{{$t('COLDSTART.BUTTON.SKIP')}}<!--건너뛰기--></span></button>
                <button type="button" class="buttons" data-type="key" v-on:click="nextStep()">{{$t('COLDSTART.BUTTON.START_GOVERNANCE')}}<!--검사시작하기--></button>
            </div>
        </div>
    </aside>
</template>
<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'popColdstartStepFirst',
        components : {

        },
        data : function(){
            return {
                isExistAccount : false,
                pending : false,
            }
        },
        created: function(){
        },
        watch: {
            curCmpnId : function(){
            }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
        },
        methods: {
            openPopup(){
                this.Common.viewPopup('popup-step-01');
                this.selectRegisteredAccountList();
            },
            nextStep(){
                this.$emit('nextStep');
            },
            closePopup(){
                this.Common.closePopup();
            },
            selectRegisteredAccountList(){
                this.pending = true;
                let url = `/api/governance/coldstart/account`;
                let header = {
                    'cmpnId': this.curCmpnId,
                };

                this.http.post(url, JSON.stringify(header))
                    .then(response=>{
                        this.pending = false;
                        if(response.data.result){
                            if(response.data.result.list && response.data.result.list.length > 0){

                                this.isExistAccount = true;
                            }
                        }
                    })
            },
            moveToPortal(){
                if(location.href.indexOf('.opsnow.com') > -1 || location.href.indexOf('.opsnow360.com') > -1){
                    window.location = `${this.urls.consoleUrl}/home/settings/accounts`;
                } else {
                    window.location = `${this.urls.portalUrl}/cloud`;
                }
            },
            finishColdstart(){
                let finishUrl = `/api/governance/coldstart/finish`;
                let data = {
                    'cmpnId': this.curCmpnId
                }
                this.http.post(finishUrl, data)
                    .then(response=>{
                        this.closePopup();
                    });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/coldstart/popColdstartStepFirst.vue